import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRoles = (resource, id, lotId) => {
  return axios.get(`/api/${resource}/${id}/setup/lots/${lotId}/roles`);
};

export const useRoles = (resource, id, lotId, options = {}) => {
  return useQuery(
    `${resource}-${id}-setup-lots-${lotId}-roles`,
    () => getRoles(resource, id, lotId),
    {
      //@ts-ignore
      initialData: { data: { data: [] } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
